import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { DisplayField } from '../../components/DisplayField';
import { formatScheduleText } from '../../utils/scheduleFormatting';
import { rendererContainer, infoBox, infoBoxBlue, optionDisplay } from './styles/commonRendererStyles';
import type { AutomationStepNodeData } from '../../types/stepNodes';

interface HandwrittenCardStepRendererProps {
	nodeId: string;
	data: AutomationStepNodeData;
	readOnly?: boolean;
}

export function HandwrittenCardStepRenderer({
	nodeId: _nodeId,
	data,
	readOnly: readOnlyProp,
}: HandwrittenCardStepRendererProps) {
	const { automationStep, stepData } = data;
	const hwcStep = automationStep as Api.HandwrittenCardAutomationStep;

	const name = hwcStep?.name || stepData?.name || '';
	const templateId = hwcStep?.templateReference?.templateId || stepData?.templateId;
	const hasContent = !!hwcStep?.content || stepData?.hasContent || false;
	const includeSignature = !hwcStep?.excludeSignature;
	const hasFallbackEmail = !!hwcStep?.conditionalSteps?.[Api.AutomationStepOutcome.Error];
	const schedule = hwcStep?.schedule || stepData?.schedule;

	const scheduleText = formatScheduleText(schedule);

	return (
		<div className={css(rendererContainer)}>
			<div className={css(infoBox)}>Schedule: {scheduleText}</div>
			<DisplayField
				label='Card title:'
				value={name}
				required
				readOnly={readOnlyProp}
				placeholder='No title set'
				withMargin
			/>
			<DisplayField
				label='Card template:'
				value={templateId ? 'Template selected' : null}
				readOnly={readOnlyProp}
				placeholder='No template selected'
				withMargin
			/>
			<DisplayField
				label='Card content:'
				value={hasContent ? 'Content entered' : null}
				readOnly={readOnlyProp}
				placeholder='No content'
				withMargin
				fieldStyle={{ minHeight: 60 }}
			/>
			<div style={{ marginBottom: 12 }}>
				<div className={css(optionDisplay)}>
					<span>{includeSignature ? '✓' : '✗'}</span>
					<span>Include signature of sender</span>
				</div>
			</div>
			{hasFallbackEmail && (
				<div className={css(infoBoxBlue)} style={{ marginTop: 12 }}>
					✓ If can&apos;t send card, send email instead
				</div>
			)}
		</div>
	);
}
